import { alertActions } from './alerts';
import authHeader from '../helpers/authHeader';

const ROOT_URL = '/api';

export const LOAD_GUESTS = 'LOAD_GUESTS';
export const LOAD_GUESTS_SUCCESS = 'LOAD_GUESTS_SUCCESS';
export const LOAD_GUESTS_FAILURE = 'LOAD_GUESTS_FAILURE';

export const ADD_GUEST = 'ADD_GUEST';
export const ADD_GUEST_SUCCESS = 'ADD_GUEST_SUCCESS';
export const ADD_GUEST_FAILURE = 'ADD_GUEST_FAILURE';

export const PUBLIC_ADD_GUEST = 'PUBLIC_ADD_GUEST';
export const PUBLIC_ADD_GUEST_SUCCESS = 'PUBLIC_ADD_GUEST_SUCCESS';
export const PUBLIC_ADD_GUEST_FAILURE = 'PUBLIC_ADD_GUEST_FAILURE';

export const REMOVE_GUEST = 'REMOVE_GUEST';
export const REMOVE_GUEST_SUCCESS = 'REMOVE_GUEST_SUCCESS';
export const REMOVE_GUEST_FAILURE = 'REMOVE_GUEST_FAILURE';

export const UPDATE_GUEST = 'UPDATE_GUEST';
export const UPDATE_GUEST_SUCCESS = 'UPDATE_GUEST_SUCCESS';
export const UPDATE_GUEST_FAILURE = 'UPDATE_GUEST_FAILURE';


export const guestActions = {
	loadGuests,
	loadGuestsSuccess,
	loadGuestsFailure,
	addGuest,
	addGuestSuccess,
	addGuestFailure,
  publicAddGuest,
  publicAddGuestSuccess,
  publicAddGuestFailure,
	removeGuest,
	removeGuestSuccess,
	removeGuestFailure,
	updateGuest,
	updateGuestSuccess,
	updateGuestFailure,
}

// -------- Load guests ---------

function loadGuests() {
	return (dispatch) => {
		const requestOptions = {
	    credentials: 'same-origin',
      headers: authHeader(),
      method: 'GET',
	  };

		return fetch(ROOT_URL + '/guests', requestOptions)
			.then(res => res.json())
			.then(res => {
				dispatch(loadGuestsSuccess(res));
			})
			.catch(error => {
				dispatch(loadGuestsFailure(error));
				dispatch(alertActions.error(error));
			});
	}
}

function loadGuestsSuccess(guests) {
	return {
    type: LOAD_GUESTS_SUCCESS,
    guests
  };
}

function loadGuestsFailure(error) {
	return {
    type: LOAD_GUESTS_FAILURE,
    error
  };
}

// -------- Add guest ---------

function addGuest(guest, callback) {
	return (dispatch) => {
		const requestOptions = {
	    body: JSON.stringify({ guest: guest }),
      credentials: 'same-origin',
      headers: authHeader(),
      method: 'POST',
	  };

		return fetch(ROOT_URL + '/guests', requestOptions)
      .then(res => res.json())
      .then(res => {
        if (res.error === true) {
          throw Error(res.text)
        }
        else {
          callback(true)
          dispatch(addGuestSuccess(res))
          dispatch(alertActions.success('Guest added successfully.'))
        }
      })
      .catch(res => {
        callback(false)
        dispatch(addGuestFailure(res))
        dispatch(alertActions.error(res || 'Something went wrong with your change.'))
      })
	}
}

function addGuestSuccess(guest) {
	return {
    type: ADD_GUEST_SUCCESS,
    guest
  };
}

function addGuestFailure(error) {
	return {
    type: ADD_GUEST_FAILURE,
    error
  };
}

// -------- Public Add guest ---------

function publicAddGuest(event, guest, callback) {
  return (dispatch) => {
    dispatch(publicAddGuestStart())

    const requestOptions = {
      body: JSON.stringify({ guest: guest }),
      credentials: 'same-origin',
      headers: {
        'content-type': 'application/json'
      },
      method: 'POST',
    }

    return fetch(`${ROOT_URL}/events/${event.token}/rsvp`, requestOptions)
      .then(res => res.json())
      .then(res => {
        if (res.error === true) {
          throw Error(res.text)
        }
        else {
          if (callback) {
            callback(true);
          }
          dispatch(publicAddGuestSuccess(res))
          // dispatch(alertActions.success('Guest added successfully.'))
        }
      })
      .catch(res => {
        if (callback) {
          callback(false);
        }
        dispatch(publicAddGuestFailure(res))
        dispatch(alertActions.error(res || 'Something went wrong with your change.'))
      })
  }
}

function publicAddGuestStart() {
  return {
    type: PUBLIC_ADD_GUEST,
  }
}

function publicAddGuestSuccess(guest) {
  return {
    type: PUBLIC_ADD_GUEST_SUCCESS,
    guest
  };
}

function publicAddGuestFailure(error) {
  return {
    type: PUBLIC_ADD_GUEST_FAILURE,
    error
  };
}

// -------- Remove guest ---------

function removeGuest(guest) {
	return (dispatch) => {
		const requestOptions = {
	    body: JSON.stringify({ guest: guest }),
      credentials: 'same-origin',
      headers: authHeader(),
      method: 'DELETE',
	  }

		return fetch(ROOT_URL + `/guests/${guest.id}`, requestOptions)
      .then(res => res.json())
      .then(res => {
        if (res.error === true) {
          throw Error(res.text)
        }
        else {
          dispatch(removeGuestSuccess(res))
          dispatch(alertActions.success('Guest removed successfully.'))
        }
      })
      .catch(res => {
        dispatch(removeGuestFailure(res))
        dispatch(alertActions.error(res || 'Something went wrong with your change.'))
      })
	}
}

function removeGuestSuccess(guest) {
	return {
    type: REMOVE_GUEST_SUCCESS,
    guest
  };
}

function removeGuestFailure(error) {
	return {
    type: REMOVE_GUEST_FAILURE,
    error
  };
}

// -------- Update guest ---------

function updateGuest(guest) {
	return (dispatch) => {
		const requestOptions = {
	    body: JSON.stringify({ guest: guest }),
      credentials: 'same-origin',
      headers: authHeader(),
      method: 'PUT',
	  };

		return fetch(ROOT_URL + `/guests/${guest.id}`, requestOptions)
      .then(res => res.json())
			.then(res => {
        if (res.error === true) {
          throw Error(res.text)
        }
        else {
          dispatch(updateGuestSuccess(res))
          dispatch(alertActions.success('Guest updated successfully'))
        }
			})
			.catch(res => {
        dispatch(updateGuestFailure(res))
        dispatch(alertActions.error(res || 'Something went wrong with your change.'))
			})
	}
}

function updateGuestSuccess(guest) {
	return {
    type: UPDATE_GUEST_SUCCESS,
    guest
  };
}

function updateGuestFailure(error) {
	return {
    type: UPDATE_GUEST_FAILURE,
    error
  };
}
